import { useEffect } from "react";
import { useParams } from "react-router-dom";

import MQTTService from "../services/mqtt";

import useNodeVersion from "./useNodeVersion";

import { MESSAGE_TYPE } from "../lib/utils/constants";

function useRequestNodeLiveStats() {
  const { cwid } = useParams();
  const { isMinV5 } = useNodeVersion();

  useEffect(() => {
    if (!isMinV5) {
      return null;
    }

    MQTTService.sendMessage({
      topic: `node/${cwid}/in`,
      message: {
        msgType: MESSAGE_TYPE.REQUEST_LIVE_STATS,
      },
    });

    const liveDataInterval = setInterval(() => {
      MQTTService.sendMessage({
        topic: `node/${cwid}/in`,
        message: {
          msgType: MESSAGE_TYPE.REQUEST_LIVE_STATS,
        },
      });
    }, 290000);

    return () => {
      if (isMinV5) {
        clearInterval(liveDataInterval);
      }
    };
  }, [cwid, isMinV5]);
}

export default useRequestNodeLiveStats;
